export function detectPlatform() {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || ''

  let osId = 'Unknown'
  let m
  if ((m = /Windows NT ([\d.]+)/.exec(ua))) {
    const map = { '10.0': '10/11', '6.3': '8.1', '6.2': '8', '6.1': '7', '6.0': 'Vista', '5.1': 'XP' }
    osId = 'Windows ' + (map[m[1]] || m[1])
  } else if ((m = /Mac OS X ([\d_]+)/.exec(ua))) {
    osId = 'macOS ' + m[1].replace(/_/g, '.')
  } else if ((m = /Android ([\d.]+)/.exec(ua))) {
    osId = 'Android ' + m[1]
  } else if ((m = /(iPhone|iPad); CPU [^ ]+ OS ([\d_]+)/.exec(ua))) {
    osId = m[1] + ' iOS ' + m[2].replace(/_/g, '.')
  } else if (/CrOS/.test(ua)) {
    osId = 'ChromeOS'
  } else if (/Linux/.test(ua)) {
    osId = 'Linux'
  }

  let browserId = 'Unknown'
  if ((m = /Edg\/([\d.]+)/.exec(ua))) browserId = 'Edge ' + m[1]
  else if ((m = /OPR\/([\d.]+)/.exec(ua))) browserId = 'Opera ' + m[1]
  else if ((m = /Firefox\/([\d.]+)/.exec(ua))) browserId = 'Firefox ' + m[1]
  else if ((m = /Chrome\/([\d.]+)/.exec(ua))) browserId = 'Chrome ' + m[1]
  else if ((m = /Version\/([\d.]+).*Safari/.exec(ua))) browserId = 'Safari ' + m[1]

  return { osId, browserId }
}

export default { detectPlatform }
